// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'

const DEFAULT = localStorage.getItem('locale') || 'en'

const i18n = createI18n({
  legacy: false,          //  允许在 <script setup> 里用 useI18n()
  locale: DEFAULT,        //  记住上次选择
  fallbackLocale: 'en',
  messages: { en, ru }
})

createApp(App)
  .use(router)            
  .use(i18n)              
  .mount('#app')
